import * as Yup from 'yup'

export const coordenadorSchema = Yup.object().shape({
  nome: Yup.string().required('Nome é obrigatório'),
  crm: Yup.string()
    .min(1, 'Mínimo de 1 caracter')
    .max(10, 'Mínimo de 10 caracteres')
    .required('Número do Conselho de Classe é obrigatório'),
  rqe: Yup.string()
    .min(1, 'Mínimo de 1 caracter')
    .max(10, 'Mínimo de 10 caracteres')
    .required('RQE é obrigatória'),
  uf: Yup.object().nullable().required('Estado é obrigatório'),
})
